
import Image from "next/image";
import { useRouter } from "next/router";
import Meta from "../../components/Meta";

const Single_post = () => {
  const router = useRouter();
  const pid = router.query.single_post; // This would typically be the ID of the blog post to fetch

  const blogPostData = {
    id: "hanson-robotics-impactoverse",
    image: "/images/new/1.png", // Replace with an actual image path
    title: "Hanson Robotics and Impactoverse: Reigniting Human Connection Through AI and Robotics",
    date: "June 28, 2025",
    time: "10 min read",
    authorImage: "/images/avatars/avatar_1.jpg", // Replace with an actual author image path
    authorName: "AI & Robotics Team",
    text: "This collaboration is not just about technological advancement—it’s about using AI and robotics to bridge the digital divide, reconnect humanity with its history, and reignite human connection in an increasingly digital world.",
    subImages: ["/images/blog/sub_image_1.jpg", "/images/blog/sub_image_2.jpg"], // Replace with actual sub-image paths
  };

  return (
    <div>
      <Meta title={`${blogPostData.title} || Impactoverse `} />

      <div className="pt-[5.5rem] lg:pt-24">
        
        <section className="relative py-16 md:py-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
            <Image
              width={1519}
              height={773}
              priority
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full w-full object-cover"
            />
          </picture>
          <div className="container" key={blogPostData.id}>


            
            <figure className="mb-16">
              <Image
                width={900}
                height={400}
                priority
                src={blogPostData.image}
                alt="post image"
                className="rounded-2xl object-cover mx-auto"
              />
            </figure>
           
            
            <article className="mb-12">
              
              <div className="article-content">
                <div className="mx-auto mb-16">
              
              <h2 className="font-display text-3xl text-jacarta-700 dark:text-white mb-8">
                Hanson Robotics and Impactoverse:  Reigniting Human Connection Through AI and Robotics
              </h2>
            </div>
                <p className="text-lg ">
                  In an era where artificial intelligence and robotics are reshaping industries, Hanson Robotics and Impactoverse are joining forces to push the boundaries of AI-driven impact. This collaboration is not just about technological advancement—it’s about using AI and robotics to bridge the digital divide, reconnect humanity with its history, and reignite human connection in an increasingly digital world.
                </p>
                <p className="text-lg">
                  By combining Hanson Robotics’ groundbreaking work in lifelike humanoid robots with Impactoverse’s mission-driven approach to technology, this partnership will develop innovative solutions that preserve cultural heritage, enhance education, and inspire social progress. Together, we are creating AI-powered experiences that are not only intelligent but also emotionally and culturally resonant.
                </p>
                <h2 className="text-lg">
                  Why This Collaboration Matters
                </h2>
                <p className="text-lg">
                  As digital interactions become more dominant, there is an urgent need to ensure that technology enhances rather than diminishes human connection. AI and robotics hold immense potential to foster empathy, preserve shared histories, and create experiences that deepen our understanding of ourselves and each other.
                </p>
                <p  className="text-lg">
                  Hanson Robotics has pioneered some of the world’s most advanced AI-driven humanoid robots, redefining human-machine interaction. Impactoverse, with its commitment to digital inclusion and purpose-driven innovation, is committed to ensuring that these technologies are harnessed for global good. By working together, we are exploring a future of AI and robotics solutions that go beyond automation and efficiency—they will serve as storytellers, educators, and bridges between past and future generations for co-creation of impactful solutions.
                </p>
                <h2 className="text-lg">
                  What We Aim to Achieve
                </h2>
                <ol className="list-decimal list-inside space-y-3 text-lg">
                  <li>
                    <b>AI and Robotics for Human Connection:</b> Developing interactive AI avatars and humanoid robots that serve as digital storytellers, preserving cultural heritage, amplifying diverse voices, and fostering meaningful conversations across generations.
                  </li>
                  <li>
                    <b>Technology as a Bridge to the Past and Future:</b> Using AI to bring history to life, while also increasing access to AI and robotics education.
                  </li>
                  <li>
                    <b>Connection-focused AI Experiences:</b> Experiences and solutions that go beyond data processing, enabling deeper learning experiences and promoting social cohesion and positive environmental impact in an increasingly fragmented world.
                  </li>
                  <li>
                    <b>Impactful, Scalable Solutions:</b> Ensuring that AI and robotics-driven experiences are accessible to communities worldwide, empowering people with knowledge, connection, and a renewed sense of shared humanity, within an ecosystem that facilitates co-creation of solutions.
                  </li>
                  <li>
                    <b>A Future of Ethical AI:</b> Demonstrating how AI and robotics can be developed and deployed responsibly, ensuring that technology remains a tool for meaningful engagement, education, and positive impact.
                  </li>
                </ol>
                <blockquote className="text-jacarta-700 !my-10 text-lg italic dark:text-white">
                  “This collaboration represents a bold step toward a future where AI and robotics are catalysts for human connection, ethical innovation and impactful action.”
                  <cite className="text-jacarta-400 text-2xs mt-3 block not-italic tracking-tight">
                    — Impactoverse Team
                  </cite>
                </blockquote>
                <p className="text-lg">
                  The future of AI-driven impact starts here. Stay tuned as we unveil groundbreaking initiatives that will redefine how we interact with technology—and with each other.
                </p>
              </div>
            </article>


          </div>
        </section>
        
      </div>
    </div>
  );
};

export default Single_post;